import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const VersionChangeModal = ({
  versions,
  version,
  versionOpen,
  toggleVersion,
  handleVersionSwitch,
}) => {
  return (
    <Modal size="sm" isOpen={versionOpen} toggle={toggleVersion} backdrop="static">
      <ModalHeader toggle={toggleVersion} className="border-bottom">
        <div className="text-center">Switch Version:</div>
      </ModalHeader>
      <ModalBody>
        <div className="row pt-2 pb-2">
          <div className="col-md-12 col-sm-12">
            <select
              name="versionSwitch"
              className="form-control"
              onChange={handleVersionSwitch}
              value={version}
            >
              {versions.map((version) => (
                <option value={version.currentVersion} key={version.currentVersion}>
                  v{version.currentVersion}
                </option>
              ))}
            </select>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default VersionChangeModal;
